module.exports = __webpack_public_path__ + "assets/images/13-2Y_Bj2G.jpg";